module.exports = __webpack_public_path__ + "img/menu_icon.5d322f8f.svg";